export default __webpack_public_path__ + "static/img-app-graphs--mobile-a2c95b0abe2542262fc7a5389a32c7c9.jpg";